import React, {useEffect, useState} from 'react';
import {LinearProgress, withStyles} from '@material-ui/core';

const StyledLinearProgress = withStyles({
    colorPrimary: {
        backgroundColor: '#FFF'
    }
})(LinearProgress);

const style = {
    top: 0,
    zIndex: 1302,
    width: '100%',
    position: 'absolute'
}

export default function BufferBar() {
    const [progress, setProgress] = useState(0);

    useEffect(() => {
        const timer = setInterval(() =>
            setProgress((oldProgress) => {
                if (oldProgress === 100) return 0;
                const diff = Math.random() * 10;
                return Math.min(oldProgress + diff, 100);
            }), 500);

        return () => clearInterval(timer);
    }, []);

    return <div style={style}>
        <StyledLinearProgress variant='determinate' value={progress}/>
    </div>
}